<template>
	<van-nav-bar :title="title" left-arrow @click-left="onClickLeft" />
</template>

<script>
export default {
	name: "navbar",
	data() {
		return {
			link: this.to
		};
	},
	props: ["title", "to"],
	methods: {
		onClickLeft() {
			if (!this.$route.meta.backHome) {
				this.$router.go(-1);
			} else {
				this.$router.push("/");
			}

			this.$emit("pageRegression", null);
		}
	},
	watch: {
		link(newVal) {
			this.link = newVal;
		}
	}
};
</script>

<style>
</style>
